/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { Button } from '@carbon/react';
import { ArrowRight } from '@carbon/icons-react';

import * as Styled from './FooterControls.styled';
/** @typedef {import('../types').ExtractionField} ExtractionField */
/**
 * @param {{
 *   totalFields: number,
 *   totalTables: number,
 *   selectedFields: ExtractionField[],
 *   selectedTables: ExtractionField[],
 *   selectedCount?: number,
 *   selectedTableCount?: number,
 *   onConfirm?: (selectedFields: ExtractionField[], selectedTables: ExtractionField[]) => void
 * }} props
 * @returns {JSX.Element}
 */
export const FooterControls = ({
  totalFields,
  totalTables,
  selectedFields,
  selectedTables,
  selectedCount = 0,
  selectedTableCount = 0,
  onConfirm
}) => {
  const hasChanges = selectedFields.length > 0 || selectedTables.length > 0;

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm(selectedFields, selectedTables);
    }
  };
  return (
    <Styled.FooterControls>
      <Styled.SelectionCount>
        {totalFields > 0 ? `${selectedCount} field${selectedCount !== 1 ? 's' : ''}` : ''}
        {totalFields > 0 && totalTables > 0 ? ' & ' : ''}
        {totalTables > 0 ? `${selectedTableCount} table${selectedTableCount !== 1 ? 's' : ''}` : ''} selected
      </Styled.SelectionCount>
      <Button
        kind="primary"
        disabled={!hasChanges}
        iconDescription="Confirm selection"
        renderIcon={ArrowRight}
        onClick={handleConfirm}
      >
        Confirm selection
      </Button>
    </Styled.FooterControls>
  );
};
